import { GADataProps } from "@components/GAData/GAData";

export const THRIVE_ABOUT_US_GA_PROPS: GADataProps = {
  title: "Thrive About Us",
  level2: "miscellaneous",
  cd_version: "bt2",
};
